// extracted by mini-css-extract-plugin
module.exports = {"container":"Wk-z","productName":"Xk-z","modal":"Yk-z","dimensions":"Zk-z","recipientEmail":"_k-z","lowStock":"al-z","recommendedFit":"bl-z","notRecommendedFit":"cl-z"};